// extracted by mini-css-extract-plugin
export default {"config":"config_ConfigPage-module_2KD_Q","label":"label_ConfigPage-module_2kkZ0"};